import { AixContentBody } from "@aix/ui"
import { EFeaturesVidmax } from "@aix/vidmax-shared/src/constants/pricing"
import { createFileRoute } from "@tanstack/react-router"
import { ReactElement, useEffect } from "react"
import { BreadcrumbBanner } from "~/components/BreadcrumbBanner"
import VidmaxCreateStepper from "~/components/VidMax/VidmaxCreateStepper"
import { useFreemiumModalContext } from "~/context/useFreemiumModalContext"
import AppLayout from "~/layouts/AppLayout"

const VidmaxPage = () => {
  const breadcrumbItems = [
    { label: "Home", href: "/home" },
    { label: "Automated Series", href: "/automated" },
    { label: "Create" },
  ]
  const { checkFeatureAccessAndShowUpgrade } = useFreemiumModalContext()
  useEffect(() => {
    const hasAccess = checkFeatureAccessAndShowUpgrade(EFeaturesVidmax.AI_AUTOMATED_SERIES)
  }, [])

  return (
    <>
      <BreadcrumbBanner items={breadcrumbItems} />

      <AixContentBody>
        <VidmaxCreateStepper />
      </AixContentBody>
    </>
  )
}

function AutomatedCreatePageWrapper() {
  return (
    <AppLayout>
      <VidmaxPage />
    </AppLayout>
  )
}

export const Route = createFileRoute("/automated-create")({
  component: AutomatedCreatePageWrapper,
})
